import React from "react";
import moment from "moment";

const RulesMessage = {
  overDue: "Duration exceeds allowed limit. Please enter reason for any service that exceeds 12 hours total time in comments.",
  endBeforeStart: "End date time should be greater than start date time.",
};

function checkOverDueTimeReason(fields, allowedMinutes) {
  let fail = false;
  if (fields && !fields.comments && fields.startDate && fields.endDate) {
    let diff = moment(fields.endDate).diff(moment(fields.startDate), "minute");
    if (diff > 0 && diff >= allowedMinutes) {
      fail = true;
    }
  }
  return fail;
}
function checkEndTimeBeforeStart(fields) {
  let fail = false;
  if (fields && fields.startDate > fields.endDate) {
    fail = true;
  }
  return fail;
}

export const ValidationResponse = (props) => {
  let messageList = props.hosValidationMessages;
  let toRet = "";
  toRet = messageList.map((message) => {
    return <li style={{ fontSize: "12px", color: "#a90000" }}>{message}</li>;
  });
  return toRet;
};

export function messageListPopulatorAndValidator(formFields) {
  let validator = {
    pass: true,
    messageList: [],
  };
  if (formFields) {
    let overDueRuleFail = checkOverDueTimeReason(formFields, 720);
    if (overDueRuleFail === true) {
      validator.pass = false;
      validator.messageList.push(RulesMessage["overDue"]);
    }
    let endBeforeStartTime = checkEndTimeBeforeStart(formFields);
    if (endBeforeStartTime === true) {
      validator.pass = false;
      validator.messageList.push(RulesMessage["endBeforeStart"]);
    }
  }
  return validator;
}



// WEBPACK FOOTER //
// ./src/components/User/HOS/validationResponse.jsx